import getAxiosBasicUrlAndHeader from 'api/helpers/getAxiosBasicUrlAndHeader'
import axios from 'axios'

/**
 * requires user to have group code 6A
 * @param {Array} ids
 * @param {*} session
 * @returns Promise success or fail message
 */
const alertUnmuteService = async (ids, session) => {
  const id = ids[0]

  const jsonBody = {
    stationCode: id.stationCode,
    blockIndex: id.blockIndex,
    bessStatusCode: id.bessStatusCode,
    startTimestamp: id.startTimestamp.epochMillis,
  }

  const { apiUrl, axiosHeader } = getAxiosBasicUrlAndHeader(session)

  return await axios
    .put(`${apiUrl}alerts/unmute`, jsonBody, axiosHeader)
    .then((res) => res.data)
}

export default alertUnmuteService
